import client from '../../client'
import { NotificationId, Notification, ListParams } from './types'
import { ApiResponse } from '../../types'

export * from './types'

export const list = async (params?: ListParams): Promise<Notification[]> => {
  const { data: notifications }: ApiResponse<Notification[]> = await client.get(
    '/user/notifications',
    {
      params: {
        ...params,
        ...(params && params.isImportant ? { isImportant: 1 } : {}),
      },
    }
  )
  return notifications
}

export const get = async (id: NotificationId): Promise<Notification> => {
  const { data: notification }: ApiResponse<Notification> = await client.get(
    `/user/notifications/${id}`
  )
  return notification
}
